
      var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgErrorLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 106.364,
  width: 92.727,
  height: 60,
  rx: 7.5,
  transform: "rotate(-90 30 106.364)",
  stroke: "#000",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 90.545,
  r: 6,
  transform: "rotate(-180 60 90.545)",
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78 32.904c-.13.298-.191.587-.358.788-.38.459-.774.922-1.231 1.298-1.324 1.09-2.684 2.133-4.025 3.202-1.087.867-2.186 1.726-3.115 2.772-.363.41-.699.85-1.002 1.307-.347.52-.357 1.07-.11 1.665.582 1.395 1.3 2.718 2.032 4.034 2.028 3.636 3.99 7.307 5.796 11.06.335.695.564 1.443.839 2.169a.874.874 0 0 1 .05.237c.033.397-.148.625-.531.55-.42-.083-.853-.212-1.221-.425a51.61 51.61 0 0 1-2.675-1.663c-2.835-1.866-5.66-3.747-8.492-5.618-1.147-.757-2.328-1.456-3.6-1.987-.965-.403-1.963-.625-3.018-.533-.8.07-1.54.332-2.256.678-1.286.624-2.443 1.453-3.579 2.31-2.272 1.714-4.526 3.452-6.795 5.17-.489.37-1.006.705-1.52 1.04-.201.133-.42.247-.646.328-.35.124-.588-.06-.536-.428.043-.301.134-.602.246-.886.6-1.522 1.19-3.047 1.825-4.554C45.097 53 46.157 50.6 47.18 48.184c.366-.864.679-1.748.87-2.676.222-1.077-.078-1.93-.991-2.532-.511-.337-1.056-.623-1.59-.925-.379-.215-.769-.411-1.147-.628a5.28 5.28 0 0 1-.605-.402c-.608-.47-.575-1.038.121-1.356.79-.36 1.603-.68 2.422-.968 1.263-.444 2.542-.837 3.809-1.268.472-.16.93-.364 1.394-.55 1.194-.478 2.138-1.283 2.825-2.356.681-1.062 1.277-2.179 1.926-3.262.308-.513.62-1.029.993-1.493.213-.265.527-.483.84-.627.59-.273 1.014-.15 1.406.37.252.335.462.704.678 1.065.399.666.776 1.347 1.185 2.007.368.593.911.971 1.592 1.097.441.082.903.15 1.344.106a98.05 98.05 0 0 0 4.223-.51c2.202-.315 4.396-.68 6.598-.985.603-.083 1.225-.05 1.836-.028.249.009.512.092.734.209.148.078.234.276.357.432z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <rect x=\"30\" y=\"106.364\" width=\"92.727\" height=\"60\" rx=\"7.5\" transform=\"rotate(-90 30 106.364)\" stroke=\"#000\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <circle cx=\"60\" cy=\"90.545\" r=\"6\" transform=\"rotate(-180 60 90.545)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M78 32.904c-.13.298-.191.587-.358.788-.38.459-.774.922-1.231 1.298-1.324 1.09-2.684 2.133-4.025 3.202-1.087.867-2.186 1.726-3.115 2.772-.363.41-.699.85-1.002 1.307-.347.52-.357 1.07-.11 1.665.582 1.395 1.3 2.718 2.032 4.034 2.028 3.636 3.99 7.307 5.796 11.06.335.695.564 1.443.839 2.169a.874.874 0 0 1 .05.237c.033.397-.148.625-.531.55-.42-.083-.853-.212-1.221-.425a51.61 51.61 0 0 1-2.675-1.663c-2.835-1.866-5.66-3.747-8.492-5.618-1.147-.757-2.328-1.456-3.6-1.987-.965-.403-1.963-.625-3.018-.533-.8.07-1.54.332-2.256.678-1.286.624-2.443 1.453-3.579 2.31-2.272 1.714-4.526 3.452-6.795 5.17-.489.37-1.006.705-1.52 1.04-.201.133-.42.247-.646.328-.35.124-.588-.06-.536-.428.043-.301.134-.602.246-.886.6-1.522 1.19-3.047 1.825-4.554C45.097 53 46.157 50.6 47.18 48.184c.366-.864.679-1.748.87-2.676.222-1.077-.078-1.93-.991-2.532-.511-.337-1.056-.623-1.59-.925-.379-.215-.769-.411-1.147-.628a5.28 5.28 0 0 1-.605-.402c-.608-.47-.575-1.038.121-1.356.79-.36 1.603-.68 2.422-.968 1.263-.444 2.542-.837 3.809-1.268.472-.16.93-.364 1.394-.55 1.194-.478 2.138-1.283 2.825-2.356.681-1.062 1.277-2.179 1.926-3.262.308-.513.62-1.029.993-1.493.213-.265.527-.483.84-.627.59-.273 1.014-.15 1.406.37.252.335.462.704.678 1.065.399.666.776 1.347 1.185 2.007.368.593.911.971 1.592 1.097.441.082.903.15 1.344.106 1.411-.139 2.82-.31 4.223-.51 2.202-.315 4.396-.68 6.598-.985.603-.083 1.225-.05 1.836-.028.249.009.512.092.734.209.148.078.234.276.357.432z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/error-logo.95d1b994b5b8bfdddf3c7f9e735f5336.svg"),
        {
          React: SvgErrorLogo,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      